import { render } from "./AudioSeriesSection.vue?vue&type=template&id=b55ec044"
import script from "./AudioSeriesSection.vue?vue&type=script&lang=js"
export * from "./AudioSeriesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__